import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const FAQS = [{
  question: 'Voor welke kinderen is Meester djay gemaakt?',
  answer: 'Voor kinderen in groep 6, 7 en 8 — zo\u2019n 9 tot 12 jaar. De stof sluit aan op het Nederlandse basisonderwijs en de Cito-doelen, dus wat je kind hier oefent, komt op school terug.'
}, {
  question: 'Welke vakken zitten erin?',
  answer: 'Tien vakken: rekenen, taal, spelling, werkwoordspelling, topografie, tijd, geld, meten, studievaardigheden en getallen. Samen zijn dat meer dan 100 vaardigheden om aan te werken — van tafels tot zinsontleding.'
}, {
  question: 'Hoe weet Meester djay wat mijn kind nodig heeft?',
  answer: 'Tijdens het oefenen kijkt Meester djay continu mee: wat lukt al, waar twijfelt je kind, waar gaat het mis? Op basis daarvan kiest hij de volgende vraag. Net moeilijk genoeg om te groeien, nooit zo moeilijk dat je kind het opgeeft.'
}, {
  question: 'Hoe weet ik zeker dat de vragen kloppen?',
  answer: 'Elke vraag gaat door 8 controles voordat je kind hem ziet — van wiskundige juistheid en niveau tot duidelijke uitleg. Komt er ook maar één \u201Cnee\u201D uit, dan komt de vraag niet door. Zo zien jullie nooit een rotte vraag.'
}, {
  question: 'Hoeveel verschillende soorten vragen zijn er?',
  answer: 'Op dit moment 38 interactieve vraagtypes en 55 visuele hulpmiddelen — denk aan getallenlijnen, klokken, breukcirkels en kaartjes om te slepen. We werken naar 200+. Je kind doet dus veel meer dan alleen meerkeuze.'
}, {
  question: 'Wat kost het?',
  answer: 'We zitten in de testfase en de demo is gratis. Meld je nu aan voor vroege toegang en je krijgt bij de lancering 6 maanden gratis. Daarna een eerlijke prijs — we sturen geen onverwachte rekeningen.'
}, {
  question: 'Is het veilig voor mijn kind?',
  answer: 'Ja. Geen advertenties, geen in-app aankopen, geen gegevens die aan derden verkocht worden. Een rustige, afgeschermde leeromgeving — niets meer en niets minder.'
}, {
  question: 'Vervangt dit de juf of meester?',
  answer: 'Nee, en dat is ook niet de bedoeling. Meester djay is er voor het oefenen thuis. Hij zorgt dat je kind precies de juiste vragen krijgt en jij ziet hoe het gaat. De leerkracht houdt de regie op school.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 lg:py-32 bg-white" data-id="element-224">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="text-center mb-16" data-id="element-226">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-6" data-id="element-227">
            Vraag maar raak
          </motion.div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-6 tracking-tight" data-id="element-228">
            Eerlijke antwoorden op{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500" data-id="element-229">
              echte ouder­vragen
            </span>
          </h2>
          <p className="text-lg text-slate-600 font-medium" data-id="element-230">
            Geen marketingpraat. Mis je iets? Mail ons gerust.
          </p>
        </div>

        <div className="space-y-3" data-id="element-231">
          {FAQS.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`border-2 rounded-2xl transition-colors duration-200 overflow-hidden ${isOpen ? 'border-orange-200 bg-[#FFF9F2]' : 'border-slate-100 bg-white hover:border-slate-200'}`} data-id="element-232">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-233">
                  <span className="text-lg font-bold text-slate-900 pr-8" data-id="element-234">
                    {faq.question}
                  </span>
                  <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-orange-100 text-orange-600' : 'bg-slate-100 text-slate-400'}`} data-id="element-235">
                    {isOpen ? <Minus className="w-5 h-5" data-id="element-236" /> : <Plus className="w-5 h-5" data-id="element-237" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-238">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-239">
                      <div className="px-6 pb-6 text-slate-600 font-medium leading-relaxed" data-id="element-240">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}